
import * as React from 'react';
import { IUploaderProps, IWithFileSelectorProps } from '../../uploader/Uploader';
import { UploadAction, IUploadActionProps } from './UploadAction';
import { IFileSystemDialogProps, FileSystemDialog } from '../../fileSystemDialog/FileSystemDialog';
import { IDecoratedProps } from '../../../utilities/components/Decorators';
import { PlatformDetection } from '@ms/utilities-browser/lib/PlatformDetection';
import { ActionBase } from '../../action/Action';
import { connectToItemCache } from '../../decorators/connectToItemCache';

const platformDetection = new PlatformDetection();

const UploadFileDialog = connectToItemCache((): Pick<IFileSystemDialogProps, 'type'> => ({ type: 'file' }))(FileSystemDialog);

class NoUpload extends React.PureComponent<IUploadFileActionProps> {
    public render(): JSX.Element {
        return React.createElement(ActionBase, {});
    }
}

export type IUploadFileActionProps = IDecoratedProps<IUploadActionProps, IWithFileSelectorProps, {}>;

export const UploadFileAction: React.ComponentType<IUploadFileActionProps> = platformDetection.isHtml5FileUploadSupported ?
    connectToItemCache((): Pick<IUploaderProps, 'fileSelector'> =>
        ({ fileSelector: UploadFileDialog }))(UploadAction) :
    NoUpload;
